import { useExtraHelper } from "features/option-controls/helpers/useExtraHelper";
import { LayoutSelector } from "../slides/LayoutSelector";
import { ColorSelector } from "../slides/ColorSelector";
import { GlassSelector } from "../slides/GlassSelector";
import { HandleSelector } from "../slides/HandleSelector";
import { ExtrasSelector } from "../slides/ExtrasSelector";

// All slides
export const slides = [
  { name: "Ontwerp", headerMainText: "Kies een ontwerp", Step: LayoutSelector },
  { name: "Kleur", headerMainText: "Kies jouw kleur", Step: ColorSelector },
  { name: "Glas", headerMainText: "Kies soort glas", Step: GlassSelector },
  { name: "Greep", headerMainText: "Kies deurbeslag", Step: HandleSelector },
  {
    name: "Extra opties",
    headerMainText: "Extra opties",
    Step: ExtrasSelector,
  },
] as const;

// If there are no extra options, remove the last slide (Extra opties)
const slides_without_extra = slides.slice(0, -1);

export function useSlides() {
  // Get extra options from helper
  const { extraOptions } = useExtraHelper();

  // If there are extra options, show the extra slide, otherwise don't show it
  const selectedSlides =
    extraOptions.length > 0 ? slides : slides_without_extra;

  // Return slides
  return { slides: selectedSlides };
}
